import usePeekEventSpaces from "../../components/hooks/use-peek-event-spaces";
import React, {useEffect, useState} from "react";
import {useAuthorization} from "../../selectors";
import {
    asIsoDate,
    isCalendarDateWithinInterval,
    isISODateAfter, subtractDays,
    useLanguage
} from "../../components/configuration/configuration";
import {EVENT_SPACE} from "../../actions/spaces";
import SidebarSimpleEntryEvent from "../../components/billboard-sidebar/lists/sidebar-simple-entry-event";
import {ErrorBoundary} from "../../components/error-boundary/ErrorBoundary";
import {SUCCESS_STATUS} from "../../actions";
import {Spinner} from "../../components/util/spinner";
import {SwiperSlide} from "swiper/react";
import SwiperContainer from "../../components/slider/swiper-container";

const CalendarSliderDaily = () => {
    const [upcomingEvents, setUpcomingEvents] = useState([]);
    const {peekEventSpacesFromDate, events, status: eventsStatus} = usePeekEventSpaces();
    const {superuser, principalUsername} = useAuthorization();
    const Lang = useLanguage();

    useEffect(() => {
        const fromIsoDate = asIsoDate(subtractDays(new Date(), 7));
        // will get public events if not authorized
        peekEventSpacesFromDate(superuser, fromIsoDate);
    }, []);

    useEffect(() => {
        if (events != null) {
            const hydratedEvents = hydrateEvents(events);
            const upcomingEvents = resolveUpcomingEvents(hydratedEvents);
            setUpcomingEvents(upcomingEvents)
        }
    }, [events])

    const resolveUpcomingEvents = (hydratedEvents) => {
        const today = new Date();
        return  hydratedEvents
        .filter(space => {
            if (space.calendarDate) {
                const isFuzzyToday = isCalendarDateWithinInterval(today,
                    space.calendarDate,
                    space.calendarDateEnd);
                const isAfter = isISODateAfter(space.calendarDate.date, today);
                space.isToday = isFuzzyToday;
                space.today = isFuzzyToday;
                return (isAfter || isFuzzyToday) && (space.type === EVENT_SPACE);
            } else return false;
        })
    }

    // flatten up multiple-day events, create daily virtual events for events running
    // longer than one day
    const hydrateEvents = (events) => {
        const hydratedEvents = []
        events.forEach(event => {
            if (event => event.calendarDates !== null && event.calendarDates.length > 1) {
                const sameDayEvents = new Map();
                const _hydratedEvents = [];

                event.calendarDates.forEach((calendarDate, idx) => {
                    const key = calendarDate.date;
                    if (sameDayEvents.get(key) == null) {
                        sameDayEvents.set(key, true);
                        _hydratedEvents.push({
                            ...event,
                            calendarDates: new Array(calendarDate),
                            calendarDate: calendarDate,
                            calendarDateEnd: null
                        })
                    }
                })
                hydratedEvents.push(..._hydratedEvents)
            } else {
                hydratedEvents.push(event)
            }
        })
        return hydratedEvents.sort(
            (left, right) => (left.calendarDate.date) < (right.calendarDate.date) ? -1 : 1)
    }

    // render todays events additionally
    const renderUpcomingEvents = () => {
        return upcomingEvents.map((space, idx) => {
            return <SwiperSlide key={space.id + "-" + idx}>
                <SidebarSimpleEntryEvent left peekspace={space}/>
            </SwiperSlide>
        })
    }

    const renderFallBack = () => {
        return <div className='mb-2'>
            {Lang.nav.sidebar.spaces.noneUpcoming}
            <p>(Something went wrong)</p>
        </div>;
    }

    if (eventsStatus !== SUCCESS_STATUS) return <Spinner/>
    if (events.length === 0) return null;

    return <ErrorBoundary fallback={renderFallBack}>
        {upcomingEvents.length > 0 && <div className='events-slider-container mb-3'>
            <SwiperContainer slidesPerView={1} pagination={false} autoplay={false}
                             breakpoints={{
                                 slidesPerView: 1,
                                 spaceBetween: 0,
                                 480: {slidesPerView: 2, spaceBetween: 10},
                                 640: {slidesPerView: 3, spaceBetween: 10},
                                 // 840: {slidesPerView: 4, spaceBetween: 10},
                             }}>
                {renderUpcomingEvents()}
            </SwiperContainer>
        </div>}
    </ErrorBoundary>
}

export default CalendarSliderDaily;